/**
 * 运行时配置读取工具
 * 
 * 运行时配置通过 /config.js 注入到 window.__APP_CONFIG__ 中。
 * 不同的部署环境只需替换 config.js 文件，无需重新构建前端。
 * 
 * config.js 格式示例:
 *   window.__APP_CONFIG__ = {
 *     API_BASE_URL: '',           // 留空 = 同源请求（Nginx 代理）
 *     BMAP_AK: 'your-baidu-map-ak'
 *   };
 */

const APP_CONFIG = window.__APP_CONFIG__ || {};

/**
 * 获取 API 基础地址
 * - 部署环境: config.js 中设置，通常留空（同源走 Nginx 代理）
 * - 开发环境: 留空，使用 webpack devServer 的 proxy
 * - 跨国/跨域场景: 配置完整 URL，如 'https://api.dianct.com'
 */
export function getApiBaseUrl() {
  return APP_CONFIG.API_BASE_URL || '';
}

/**
 * 获取百度地图 AK
 */
export function getBmapAk() {
  return APP_CONFIG.BMAP_AK || '';
}

/**
 * 获取完整 API URL（拼接 baseUrl + path）
 */
export function getApiUrl(path) {
  const base = getApiBaseUrl();
  // path 应以 / 开头
  return base + path;
}

export default {
  getApiBaseUrl,
  getBmapAk,
  getApiUrl
};
